import React, { useEffect, useState } from 'react';
import { FormattedMessage, useIntl } from 'react-intl';
import PropTypes from 'prop-types';
import AdminPushNotificationRow from './adminPushNotificationRow.js';
import { Link } from 'react-router-dom';
import Helmet from 'react-helmet';
import CustomPaginator from '../../components/paginator';
import { usePushNotifications } from './apiHooks';
import Loader from '../../components/loader';
import ErrorMessage from '../../components/errorMessage';
import utils from '../../utils/utils';

const RESULTS_PER_PAGE = 30;

const AdminPushNotifications = () => {
  const [sortBy, setSortBy] = useState('idDesc');
  const [activePage, setActivePage] = useState(1);

  const {
    isLoading: loading,
    result,
    isError,
    error,
    refetch,
  } = usePushNotifications({
    sortBy,
    max: RESULTS_PER_PAGE,
    offset: (activePage - 1) * RESULTS_PER_PAGE,
  });

  useEffect(() => {
    refetch();
  }, [sortBy, activePage]);

  function setSortMethod(newSortBy) {
    let sortParam;

    switch (newSortBy) {
      case 'id':
      default:
        sortParam = sortBy === 'idAsc' ? 'idDesc' : 'idAsc';
    }

    setSortBy(sortParam);
  }

  const { formatMessage } = useIntl();

  const paginator = (
    <div className="m-b-3 m-t-3">
      <CustomPaginator
        activePage={activePage}
        resultsPerPage={RESULTS_PER_PAGE}
        setActivePage={(newNumber) => {
          if (newNumber !== activePage) {
            setActivePage(newNumber);
          }
        }}
        totalCount={result?.totalCount || 0}
      />
    </div>
  );

  return (
    <div>
      <Helmet>
        <title>{formatMessage({ id: 'admin.push.notifications.title' })}</title>
      </Helmet>

      <h3>
        <FormattedMessage id={'admin.push.notifications.title'} />
      </h3>

      <Loader show={loading} />
      {isError ? <ErrorMessage error={utils.getErrorMessageFromResponse(error)} /> : ''}

      {paginator}

      <div className="m-b-3">
        <Link className="btn btn-default" to="/admin/pushNotifications/create">
          <FormattedMessage id={'admin.button.create'} />
        </Link>
      </div>

      <table className="table table-striped admin__table">
        <thead>
          <tr>
            <th scope="col">Id</th>
            <th scope="col">Title</th>
            <th scope="col">Content</th>
            <th scope="col">For everyone</th>
            <th scope="col">Service areas</th>
            <th scope="col">Users</th>
            <th scope="col">Date created</th>
          </tr>
        </thead>
        <tbody>
          {result?.pushNotifications?.map((pushNotification, index) => (
            <AdminPushNotificationRow pushNotification={pushNotification} key={index} />
          ))}
        </tbody>
      </table>

      {paginator}
    </div>
  );
};

AdminPushNotifications.propTypes = {
  setLoading: PropTypes.func.isRequired,
  setError: PropTypes.func.isRequired,
};

AdminPushNotifications.defaultProps = {};

export default AdminPushNotifications;
